import { de } from 'yup-locales';
import { enLocale } from 'yup';
import { cloneDeep } from 'lodash';

const en = cloneDeep(enLocale);

export { en, de };
